export const KEY_RETURN = 13;
export const KEY_SHIFT = 16;
export const KEY_CONTROL = 17;
export const KEY_ESCAPE = 27;
export const KEY_SPACE = 32;
